<template>
  <BaseCard :noPadding="true" class="tw:p-5">
    <div
      class="tw:flex tw:flex-col tw:md:flex-row tw:justify-between tw:md:items-center tw:gap-y-4"
      data-testid="hotel-offers-banner-content"
    >
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-y-4 tw:md:gap-x-4 tw:items-center">
        <img :src="hotelOfferIcon" :alt="$t('hotel_offers_product_header')" class="tw:max-h-[40px] tw:max-w-[40px]" />
        <div class="tw:flex tw:flex-col tw:gap-y-1">
          <p class="tw:font-bold tw:text-xl">{{ $t(title) }}</p>
          <p>{{ $t(text) }}</p>
        </div>
      </div>
      <MainButton @click="redirectToHotelOffers" class="tw:w-full tw:md:w-auto" data-testid="hotel-offers-banner-cta">{{
        $t('plus_notification_cta_offer_setup')
      }}</MainButton>
    </div>
  </BaseCard>
</template>
<script setup>
import { useRouter } from 'vue-router'

import MainButton from '@/components/base/buttons/MainButton.vue'
import BaseCard from '@/components/dashboard/BaseCard.vue'

const hotelOfferIcon = new URL(`../../../assets/img/hotel-offers/icons/UI/offer.png`, import.meta.url)

const router = useRouter()
defineProps({
  title: String,
  text: String,
})

const redirectToHotelOffers = () => {
  router.push({ name: 'hotel-offers' })
}
</script>
